/**
 * The download name from a Content-Disposition header. A name outside ASCII (the Japanese or
 * Ukrainian training record) comes as RFC 5987 `filename*=UTF-8''…` next to an ASCII stand-in
 * with underscores, so the encoded form wins when both are present.
 */
export const contentDispositionFileName = (disposition: string | undefined): string | undefined => {
  const encoded = disposition?.match(/filename\*=UTF-8''([^;]+)/i)?.[1];
  if (encoded) {
    try {
      return decodeURIComponent(encoded.trim());
    } catch {
      // A malformed escape falls through to the plain name.
    }
  }
  return disposition?.match(/filename="?([^";]+)"?/)?.[1];
};
